import React, { useState } from 'react';
import { connect } from 'react-redux';
import { HistoryBehavioralDrawerData, TBehavioralDataResponse } from 'types/life-id';
import TStore from '../../../../types/store';
import HistoryBehavioralDrawer from '../history-behavioral-drawer';
import { BehavioralListSC } from './behavioral-list.styled';
import StepsWidget from './steps-widget';

interface BehavioralListProps {
  userId: string;
  behavioralData: TBehavioralDataResponse | null;
}

const BehavioralList: React.FC<BehavioralListProps> = ({ userId, behavioralData }) => {
  const [drawer, setDrawer] = useState(false);
  const [drawerData, setDrawerData] = useState<HistoryBehavioralDrawerData | undefined>(undefined);
  return (
    <>
      <BehavioralListSC>
        <StepsWidget
          data={behavioralData?.steps}
          onDetailOpen={() => {
            setDrawerData({
              type: 'STEPS',
            });
            setDrawer(true);
          }}
        />
      </BehavioralListSC>
      {drawerData && (
        <HistoryBehavioralDrawer
          userId={userId}
          visible={drawer}
          drawerData={drawerData}
          onClose={() => setDrawer(false)}
        />
      )}
    </>
  );
};

const mapStateToProps = (store: TStore) => ({
  behavioralData: store.lifeId.behavioralData,
});

export default connect(mapStateToProps)(BehavioralList);
